<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }"
      style="background: transparent; box-shadow: none;">
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6 class="font-web f-18"><a @click="gotoMainType" class="mr-5">
                <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติ <span
                class="ml-5 text-danger font-weight-bold">Flexible Day</span>
            </h6>
            <p class="form-sub-title font-web ml-20">&nbsp;&nbsp;Flexible Request Form</p>
          </a-col>
        </a-row>
      </template>
      <!-- form -->
      <a-row :gutter="24" type="flex" align="stretch">
        <!-- history -->
        <a-col :xs="24" :sm="24" :md="0" :lg="1" :xl="1"></a-col>
        <a-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" class="h-full">
          <historyRequest :dataRequest="dataHistory" textHead="Flexible" :loadingList='loadingList' class="h-full" />
        </a-col>
        <a-col :xs="24" :sm="24" :md="16" :lg="15" :xl="15">
          <div class="form-container">
            <a-form class="mt-10 mb-0 font-web" :layout="'horizontal'">
              <a-descriptions bordered title="" size="small">
                <a-descriptions-item :span="3">
                  <div slot="label">
                    <p class="mt-0 mb-0 font-web">
                      เลือกวันหยุดที่มาปฏิบัติงาน
                      <span class="text-danger">*</span>
                    </p>
                  </div>
                  <a-date-picker v-model="formFixableDay.selected_date" :disabled-date="disabledWorkDate"
                    format="YYYY-MM-DD" placeholder="Start" :mode="['date']" @openChange="handleStartOpenChange"
                    :disabled="!calendarReady" />
                </a-descriptions-item>
                <a-descriptions-item :span="3">
                  <div slot="label">
                    <p class="mt-0 mb-0 font-web">
                      เลือกวันปฏิบัติงานที่ต้องการแลก
                      <span class="text-danger">*</span>
                    </p>
                  </div>
                  <a-date-picker v-model="formFixableDay.move_to_date" :disabled-date="disabledHolidayDate"
                    format="YYYY-MM-DD" placeholder="End" :mode="['date']" :open="endOpen"
                    :disabled="formFixableDay.selected_date === null" @openChange="handleEndOpenChange" />
                </a-descriptions-item>
              </a-descriptions>

              <div class="mt-10 mb-10 text-center">
                <a-radio-group size="small" v-model="formFixableDay.sel_type" button-style="solid">
                  <a-radio-button v-for="(r, index) in [
                    { text: 'เต็มวัน Full Day', val: 'full-day' },
                    { text: 'ครึ่งวันเช้า AM : Half Day', val: 'am-half-day' },
                    { text: 'ครึ่งวันบ่าย PM : Half Day', val: 'pm-half-day' },
                  ]" :key="'r' + index" :value="r.val">
                    <p class="mt-0 mb-0 font-web">{{ r.text }}</p>
                  </a-radio-button>
                </a-radio-group>
              </div>

              <h6 class="mt-20 mb-10 font-web">
                รายละเอียดการปฏิบัติงาน <span class="text-danger">*</span>
              </h6>
              <a-form-item>
                <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formFixableDay.detail" />
              </a-form-item>

              <div class="mt-20 mb-20" v-if="this.$store.state.role.RulesUser.permissions.indexOf(
                `IC-HRI:chief`
              ) >= 0
              ">
                <h6 class="mt-0 mb-0 font-web">
                  Upload documents ( For chief to hr ):
                  <span class="text-danger">*</span>
                </h6>
                <a-upload :file-list="fileListCheif" :remove="handleCheifRemove" :before-upload="beforeCheifUpload"
                  :multiple="false" v-model="formFixableDay.cheifFile" accept="image/*;capture=camera">
                  <a-button class="mt-10">
                    <a-icon type="upload" /> Select File
                  </a-button>
                </a-upload>
              </div>
              <a-form-item class="mt-20 mb-10">
                <a-row :gutter="24">
                  <a-col class="mb-10" :xs="8" :sm="8" :md="12">
                    <a-button type="danger" @click="clearForm">
                      <b>ยกเลิกการขอ</b>
                    </a-button>
                  </a-col>
                  <a-col :style="{ textAlign: 'right' }" class="mb-10" :xs="16" :sm="16" :md="12">
                    <a-button type="primary" class="font-web pa-10" @click="dialogConfirm = true" size="lg"
                      style="font-size: 14px" :disabled="formFixableDay.selected_date === null ||
                        formFixableDay.move_to_date === null
                        ">
                      ส่งคำขออนุมัติ
                    </a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <!-- dialog -->
    <a-modal title="Confirm" :visible="dialogConfirm" @ok="submitRequest" @cancel="clearForm">
      <p v-if="boxFlexError.length === 0" class="mt-10 mb-20">
        Are you sure to Submit ?
      </p>
      <a-spin v-if="loading" tip="Loading..."></a-spin>
      <div v-if="boxFlexError.length !== 0">
        <a-alert :message="`Error The date you selected cannot be redeemed ::`" type="error" show-icon>
          <div slot="description">
            <span v-if="boxFlexError[0].msg === undefined">
              {{ boxFlexError[0] }}
            </span>
            <span v-else>{{ boxFlexError[0].msg }}</span>
          </div>
        </a-alert>
      </div>
    </a-modal>
  </div>
</template>

<script>
const form = {
  selected_date: null,
  move_to_date: null,
  detail: "",
  cheifFile: null,
  sel_type: "full-day",
};
import historyRequest from './history_request.vue';
import { hriRequestMixin } from "@/mixins/hriRequestMixin";
export default {
  mixins: [hriRequestMixin],
  components: {
    historyRequest
  },
  data() {
    return {
      dialogConfirm: false,
      // form
      formFixableDay: { ...form },
      loading: false,
      endOpen: false,
      // config
      mode1: "time",
      dataDayNotFlex: [],
      calendarReady: false,
      // error
      boxFlexError: [],
      // file
      fileListCheif: [],
      dataHistory: [],
      loadingList: false,
      // 
      stYear: [],
      stMonthBud: [],
      groupView: []
    };
  },
  watch: {
    "formFixableDay.selected_date"(newVal) {
      this.formFixableDay.move_to_date = null;
    },
  },
  async mounted() {
    await Promise.all([
      this.initBudgetYear(),
      this.getDaySetting(),
    ]);
    this.calendarReady = true;
    this.getAllRequest();
  },
  methods: {
    clearForm() {
      this.formFixableDay = { ...form }
      this.fileListCheif = []
      this.dialogConfirm = false
    },
    async getAllRequest() {
      await this.loadRequestHistory('/hri/flexible-day/me/', { start: 'start', end: 'end' });
    },
    disabledWorkDate(date) {
      const m = this.moment(date);
      const dayName = m.format("dddd");
      if (["Saturday", "Sunday", 'เสาร์', 'อาทิตย์'].includes(dayName)) {
        return false;
      } else {
        if (this.dataDayNotFlex.includes(m.format("YYYY-MM-DD"))) {
          return false;
        } else {
          return true;
        }
      }
    },
    disabledEndDate(endValue) {
      const startValue = this.formFixableDay.selected_date;
      if (!endValue || !startValue) {
        return false;
      }
      return this.formFixableDay.selected_date.valueOf() >= endValue.valueOf();
    },
    async getDaySetting() {
      this.dataDayNotFlex = [];
      let nextY = this.moment().add(1, "year").format("YYYY");
      let e = this.moment(`${nextY}-09-30`).format("YYYY-MM-DD");
      let s = this.moment(`${Number.parseInt(this.moment().format("YYYY")) - 1}-10-01`).format(
        "YYYY-MM-DD"
      );
      const data = await this.fetchCalendarData(s, e);
      if (data) {
        for (let h = 0; h < data.length; h++) {
          const listD = data[h];
          if (
            !["seminar", "payday", "announce", "event", "other"].includes(
              listD.calendar_type
            )
          ) {
            this.dataDayNotFlex.push(listD.extra_date);
          }
        }
      }
      // console.log(this.dataDayNotFlex);
    },
    isDateOutOfRange(date) {
      return this.moment(date).format("YYYY-MM-DD") > this.moment("2027-10-31").format("YYYY-MM-DD");
    },
    isWeekend(date) {
      const d = this.moment(date).format("dddd");
      return d === "Saturday" || d === "Sunday";
    },
    isNonFlexDay(date) {
      return this.dataDayNotFlex.includes(this.moment(date).format("YYYY-MM-DD"));
    },
    disabledHolidayDate(date) {
      if (this.isDateOutOfRange(date)) return true;
      if (this.isWeekend(date)) return true;

      const startValue = this.formFixableDay.selected_date;
      if (!date || !startValue) return false;

      if (this.isNonFlexDay(date)) return true;

      return startValue.valueOf() >= date.valueOf();
    },
    handleCheifRemove(file) {
      this.removeFileFromList(file, 'fileListCheif');
    },
    beforeCheifUpload(file) {
      if (this.isValidFile(file)) {
        this.formFixableDay.cheifFile = file;
        this.fileListCheif = [...this.fileListCheif, file];
      }
      return false;
    },
    async submitRequest() {
      this.boxFlexError = [];
      this.loading = true;
      const sendData = new FormData();
      sendData.append(
        "selected_date",
        this.moment(this.formFixableDay.selected_date).format("YYYY-MM-DD")
      );
      sendData.append(
        "move_to_date",
        this.moment(this.formFixableDay.move_to_date).format("YYYY-MM-DD")
      );
      sendData.append("detail", this.formFixableDay.detail);
      sendData.append("flex_type", this.formFixableDay.sel_type);
      if (
        this.$store.state.role.RulesUser.permissions.indexOf(`IC-HRI:chief`) >= 0
      ) {
        sendData.append("chief_backup", this.formFixableDay.cheifFile);
      }
      try {
        const response = await this.$http.post(
          "/hri/flexible-day/add_request/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.loading = false;
          this.clearForm();
          this.$success({
            title: "This is a success message",
            content: (
              <div>
                <p class="mt-0 mb-0">Success : send request Fixable Day</p>
                <p class="font-web mt-0 mb-0">
                  (ข้อมูลของท่านถูกบันทึกเรียบร้อย)
                </p>
              </div>
            ),
          });
          this.$router
            .push({
              path: "/hri/",
            })

        } else {

          const err = new Error('API Error');
          err.response = response;
          throw err;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h(
                "strong",
                { class: "font-web" },
                `Error ${error.response.status}`
              ),
            ]);
          },
          description: `Problem issue connect api : /hri/flexible-day/add_request/`,
        });
        this.boxFlexError.push(error.response.data);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.f-14 {
  font-size: 14px;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.form-sub-title {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.form-container {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  background: #ffffff;
}

.h-full {
  height: 100%;
}
</style>